import { Injectable } from '@angular/core';

import { grpcOperator } from '@lyra/app/core/api/grpc/pipe-operators/grpc';
import { MainApi } from '@mark/web-contracts';
import { from } from 'rxjs';

import { GRpcRequestType } from '../grpc-class.type';
import { GrpcCommonService } from './common.service';

export type IGetArticleById = GRpcRequestType<MainApi.DataContentGrpcContractClient['GetArticleById']>;

@Injectable()
export class DataContentGrpcContractService extends GrpcCommonService<MainApi.DataContentGrpcContractClient> {
  constructor(protected _GrpcContract: MainApi.DataContentGrpcContractClient) {
    super();
  }

  getArticleById(request: IGetArticleById) {
    return from(
      this._GrpcContract.GetArticleById(
        new MainApi.WebRequest_Guid(MainApi.WebRequest_Guid.fromObject(request)),
        this.getMetadata(),
      ),
    ).pipe(grpcOperator());
  }
}
